import { t } from "@/i18n-js/instance";
import { Typography } from "@circle-react-uikit/Typography";
import { useSignInUrl } from "./hooks/useSignInUrl";

export interface LoginMessageProps {
  buttonTextColor?: string;
}

export const LoginMessage = ({
  buttonTextColor = "text-white",
}: LoginMessageProps) => {
  const { canSignIn, redirectToUrl } = useSignInUrl();
  if (!canSignIn) {
    return null;
  }

  return (
    <div className="mt-6 flex items-center justify-center gap-3">
      <Typography.LabelSm as="span" weight="semibold" color="text-disabled">
        {t("public_live_stream.pre_join.already_a_member")}
      </Typography.LabelSm>
      <button
        type="button"
        onClick={redirectToUrl}
        className="border-very-dark border-b"
      >
        <Typography.LabelSm as="span" weight="semibold" color={buttonTextColor}>
          {t("public_live_stream.pre_join.login")}
        </Typography.LabelSm>
      </button>
    </div>
  );
};
